import React from "react";
import { FallingLines } from "react-loader-spinner";
import localization from "../../services/localization";

const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-background z-50">
      <FallingLines
        color="var(--primary-icon)"
        width="100"
        visible={true}
        ariaLabel="falling-circles-loading"
      />
      <h4 className="mt-4 text-sm font-medium">
        {localization.loading || "Loading..."}
      </h4>
    </div>
  );
};

export default LoadingSpinner;
